// src/components/Header/hooks/useHeaderCategories.js
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// import { setSelectedSubOption, setIsWaiting } from '../../ChatApp/chatSlice';
// import { selectSelectedSubOption } from '../../ChatApp/chatSlice';
import { setSelectedSubOption, setIsWaiting } from '../components/ChatApp/chatSlice';
import { selectSelectedSubOption } from '../components/ChatApp/chatSlice';

export const useHeaderCategories = (setChatType) => {
  const dispatch = useDispatch();
  const selectedSubOption = useSelector(selectSelectedSubOption);
  const [selectedCategory, setSelectedCategory] = useState('taxLawyer');
  const [isOpenCategory, setIsOpenCategory] = useState(false);
  const [isOpenSub, setIsOpenSub] = useState(false);

  const categoryOptions = {
    taxLawyer: {
      label: 'Налоговый юрист',
      subOptions: [
        { value: 'quick', label: 'Налоговый консультант' },
      ],
    },
    accountant: {
      label: 'Бухгалтер',
      subOptions: [
        { value: 'quick_fin', label: 'Помощник бухгалтера' },
      ],
    },
    generalLawPractice: {
      label: 'Юрист',
      subOptions: [
        { value: 'quick_all', label: 'Помощник юриста' },
        { value: 'docs_edit', label: 'Редактирование документа' },
        { value: 'advance_report', label: 'Авансовый отчет' },
        { value: 'contractAnalysis_all', label: 'Анализ рисков договора' },
        { value: 'law_claim_work', label: 'Судебно-претензионная работа' },
        { value: 'law_contract_creation', label: 'Договорная работа' },
        { value: 'law_corporate_docs_letters', label: 'Корпоративные документы и письма' },
        { value: 'law_posts_articles', label: 'Статьи и посты' },
        { value: "okof_identifyer", label: "Определить ОКОФ" },
      ],
    },
  };

  const handleCategoryChange = (category) => {
    setIsOpenCategory(!isOpenCategory);
    const subOption = categoryOptions[category].subOptions[0].value;
    setSelectedCategory(category);
    dispatch(setSelectedSubOption(subOption));
    dispatch(setIsWaiting(false));
    setChatType(subOption);
  };

  const handleSubOptionChange = (subOption) => {
    setIsOpenSub(!isOpenSub);
    dispatch(setSelectedSubOption(subOption));
    dispatch(setIsWaiting(false));
    setChatType(subOption);
  };

  return {
    selectedCategory,
    selectedSubOption,
    categoryOptions,
    handleCategoryChange,
    handleSubOptionChange,
    isOpenCategory,
    isOpenSub,
    setIsOpenCategory,
    setIsOpenSub,
  };
};
